import { Typography } from "@mui/material";

export function ItemsTotal({ count }: { count: number | undefined }) {
  return (
    <Typography variant="overline" color="text.secondary" mb={1}>
      จำนวน {count ?? 0} รายการ
    </Typography>
  );
}
